export type BundledImage = {
  src: string;
  srcSet: string;
  width: number;
  height: number;
  kind: 'avatar' | 'gym' | 'hero';
};

const sampleSizes: Record<string, [number, number]> = {
  rack: [1280, 720],
  bench: [1152, 864],
  barbell: [1152, 864],
  dumbbells: [864, 1152],
  door: [1280, 720],
  floor: [1024, 1024],
};

function image(
  root: string,
  widths: number[],
  width: number,
  height: number,
  kind: BundledImage['kind'],
): BundledImage {
  const src = `${root}.webp`;
  return {
    src,
    srcSet: widths
      .map((size) => `${size === width ? src : `${root}-${size}.webp`} ${size}w`)
      .join(', '),
    width,
    height,
    kind,
  };
}

/** Exact local artwork allowlist also upgrades URLs retained in older demo state. */
export function bundledImage(source?: string | null): BundledImage | null {
  if (!source) return null;
  const avatar =
    /^\/images\/demo-members\/(member-[1-5]-avatar)(?:-(?:96|192))?\.(?:png|webp)$/.exec(source);
  if (avatar) return image(`/images/demo-members/${avatar[1]}`, [96, 192, 384], 384, 384, 'avatar');
  const gym = /^\/images\/demo-members\/(member-[1-5]-gym)(?:-(?:640|1024))?\.(?:png|webp)$/.exec(
    source,
  );
  if (gym) return image(`/images/demo-members/${gym[1]}`, [640, 1024, 1536], 1536, 1024, 'gym');
  if (/^\/images\/garage-hero(?:-(?:640|1024))?\.(?:png|webp)$/.test(source))
    return image('/images/garage-hero', [640, 1024, 1536], 1536, 1024, 'hero');
  const sample =
    /^\/images\/gym-samples\/gym-sample-(rack|bench|barbell|dumbbells|door|floor)(?:-480)?\.(?:jpg|webp)$/.exec(
      source,
    );
  if (!sample) return null;
  const [width, height] = sampleSizes[sample[1]];
  return image(`/images/gym-samples/gym-sample-${sample[1]}`, [480, width], width, height, 'gym');
}
